import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Cruise = () => {
  return (
    <SvgIcon
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <mask
        id="mask0"
        // eslint-disable-next-line react/no-unknown-property
        mask-type="alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="22"
        height="22">
        <path
          d="M4.15 18.35L4.85 17.65C3.77229 16.3726 2.99639 14.8686 2.58 13.25L11 8.57L19.42 13.25C19.0036 14.8686 18.2277 16.3726 17.15 17.65L17.85 18.35C19.1557 16.855 20.0667 15.0571 20.5 13.12L20.6 12.75L16.5 10.5V4.5H13.5V0.5H8.5V4.5H5.5V10.5L1.42 12.75L1.52 13.12C1.9475 15.0551 2.85152 16.8529 4.15 18.35ZM9.5 1.5H12.5V4.5H9.5V1.5ZM6.5 5.5H15.5V9.93L11 7.43L6.5 9.93V5.5ZM21.5 17.63C21.2454 19.5127 19.8087 21.0179 17.94 21.36C16.4909 21.5455 15.0616 20.8948 14.25 19.68C13.5325 20.7848 12.3169 21.4655 11 21.5C9.69246 21.4767 8.47886 20.8158 7.75 19.73C6.93838 20.9448 5.50913 21.5955 4.06 21.41C2.17549 21.0621 0.734433 19.532 0.5 17.63L1.5 17.5C1.69525 18.9388 2.77776 20.0975 4.2 20.39C5.53859 20.5086 6.79872 19.7428 7.31 18.5L7.76 17.63L8.2 18.5C8.671 19.6497 9.75969 20.4273 11 20.5C12.2403 20.4273 13.329 19.6497 13.8 18.5L14.24 17.62L14.69 18.49C15.1994 19.7333 16.4624 20.4967 17.8 20.37C19.2161 20.08 20.2969 18.9311 20.5 17.5L21.5 17.63Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0)">
        <path
          d="M4.15 18.35L4.85 17.65C3.77229 16.3726 2.99639 14.8686 2.58 13.25L11 8.57L19.42 13.25C19.0036 14.8686 18.2277 16.3726 17.15 17.65L17.85 18.35C19.1557 16.855 20.0667 15.0571 20.5 13.12L20.6 12.75L16.5 10.5V4.5H13.5V0.5H8.5V4.5H5.5V10.5L1.42 12.75L1.52 13.12C1.9475 15.0551 2.85152 16.8529 4.15 18.35ZM9.5 1.5H12.5V4.5H9.5V1.5ZM6.5 5.5H15.5V9.93L11 7.43L6.5 9.93V5.5ZM21.5 17.63C21.2454 19.5127 19.8087 21.0179 17.94 21.36C16.4909 21.5455 15.0616 20.8948 14.25 19.68C13.5325 20.7848 12.3169 21.4655 11 21.5C9.69246 21.4767 8.47886 20.8158 7.75 19.73C6.93838 20.9448 5.50913 21.5955 4.06 21.41C2.17549 21.0621 0.734433 19.532 0.5 17.63L1.5 17.5C1.69525 18.9388 2.77776 20.0975 4.2 20.39C5.53859 20.5086 6.79872 19.7428 7.31 18.5L7.76 17.63L8.2 18.5C8.671 19.6497 9.75969 20.4273 11 20.5C12.2403 20.4273 13.329 19.6497 13.8 18.5L14.24 17.62L14.69 18.49C15.1994 19.7333 16.4624 20.4967 17.8 20.37C19.2161 20.08 20.2969 18.9311 20.5 17.5L21.5 17.63Z"
          fill="black"
        />
        <path d="M23 -1H-1V23H23V-1Z" fill="#005EDC" />
      </g>
    </SvgIcon>
  );
};

export default Cruise;
